import React, { createContext, useContext,  useReducer } from "react";

export interface SwitchAccState {
    dataVersion: number, // 数据版本
}

export type Payload =
    "SWITCH_ACCOUNT"



const reducer = (state: SwitchAccState, type: Payload): SwitchAccState => {
    switch (type) {
        case 'SWITCH_ACCOUNT':
            return { dataVersion: state.dataVersion + 1 };
        default:
            return state;
    }
};


const initState: SwitchAccState = {
    dataVersion: 0, // 数据版本
};

interface ContextProps {
    switchState: SwitchAccState,
    switchDispatch: React.Dispatch<Payload>
}

const SwitchAccContext = createContext<ContextProps>({
    switchState: initState, switchDispatch: () => {

    }
});


export function SwitchProvider({ children }: { children: React.ReactNode }) {
    const [switchState, switchDispatch] = useReducer(reducer, initState);
    return (<SwitchAccContext.Provider value={{ switchState, switchDispatch }}>{children}</SwitchAccContext.Provider>);
}

export const useSwitchAccStore = () => {
    return useContext(SwitchAccContext);
};
